<template>
  <footer>
    <div class="row sinmargen fondo-gris">
      <div class="container">
        <div class="row enlaces-rapidos">
          <div class="col-md-3">
            <div>
              <br />
              <img :alt="configData.general.brandName" src="@/assets/logo.png" width="120px" />
            </div>
          </div>
          <div class="col-md-3">
            <h4 style="color: var(--primary-color); text-align: left;">
              <strong>ENLACES RÁPIDOS</strong>
            </h4>
            <br />
            <ul style="text-align: left; padding-left: 0px;">
              <template v-for="section in section_list">
                <li style="list-style-type: none; margin-bottom: 8px;">
                  <router-link
                    :to="'/' + section.url_es"
                    style="font-size: 15px; text-decoration: none;"
                    ><span style="color: var(--secondary-color); font-weight: bold;">{{
                      section.name_sec_es
                    }}</span></router-link
                  >
                </li>
              </template>
            </ul>
          </div>
          <div class="col-md-3">
            <br />
            <br />
            <ul style="text-align: left; padding-left: 0px;">
              <li
                style="list-style-type: none; margin-bottom: 8px;"
                v-if="configData.general.isLoggingAvailable"
              >
                <a
                  href=""
                  style="font-size: 15px; text-decoration: none;"
                  data-toggle="modal"
                  data-target="#myModal2"
                  ><span style="color: var(--secondary-color); font-weight: bold;"
                    >Iniciar Sesión</span
                  ></a
                >
              </li>
              <li
                style="list-style-type: none; margin-bottom: 8px;"
                v-if="configData.general.isLoggingAvailable"
              >
                <router-link :to="'/registrar'" style="font-size: 15px; text-decoration: none;"
                  ><span style="color: var(--secondary-color); font-weight: bold;">
                    Mi Cuenta</span
                  ></router-link
                >
              </li>
              <li
                style="list-style-type: none; margin-bottom: 8px;"
                v-if="configData.general.isEcommercePage"
              >
                <router-link :to="'/carrito'" style="font-size: 15px; text-decoration: none;"
                  ><span style="color: var(--secondary-color); font-weight: bold;"
                    >Mi Carrito</span
                  ></router-link
                >
              </li>
              <li style="list-style-type: none; margin-bottom: 8px;">
                <a
                  href="https://www.armasperu.com.pe/documents/TERMINOS%20Y%20CONDICIONES%20ARMAQ.pdf"
                  target="_blank"
                  ><span style="color: var(--secondary-color); font-weight: bold;"
                    >Términos y Condiciones</span
                  ></a
                >
              </li>
              <li style="list-style-type: none; margin-bottom: 8px;">
                <a
                  href="https://www.armasperu.com.pe/documents/Servicio%20Tecnico.pdf"
                  target="_blank"
                  ><span style="color: var(--secondary-color); font-weight: bold;"
                    >Servicio Técnico</span
                  ></a
                >
              </li>
              <li style="list-style-type: none; margin-bottom: 8px;">
                <a
                  href="https://www.armasperu.com.pe/documents/Políticas%20de%20Protección%20de%20Datos%20Personales.pdf"
                  target="_blank"
                  ><span style="color: var(--secondary-color); font-weight: bold;"
                    >Políticas de Protección de Datos Personales</span
                  ></a
                >
              </li>
              <li style="list-style-type: none; margin-bottom: 8px;">
                <a
                  href="https://www.armasperu.com.pe/documents/Politicas%20de%20Venta.pdf"
                  target="_blank"
                  ><span style="color: var(--secondary-color); font-weight: bold;"
                    >Políticas de Venta</span
                  ></a
                >
              </li>
              <li style="list-style-type: none; margin-bottom: 8px;">
                <a
                  href="https://www.armasperu.com.pe/documents/Forma%20de%20Pago.pdf"
                  target="_blank"
                  ><span style="color: var(--secondary-color); font-weight: bold;"
                    >Forma de Pago</span
                  ></a
                >
              </li>
              <li style="list-style-type: none; margin-bottom: 8px;">
                <a href="https://cloud.horizontcpe.com/ConsultaComprobanteE/" target="_blank"
                  ><span style="color: var(--secondary-color); font-weight: bold;"
                    >Consultar Comprobante Electrónico</span
                  ></a
                >
              </li>
            </ul>
          </div>
          <div class="col-md-3">
            <h4 style="color: var(--primary-color); text-align: left;">
              <strong>MANTÉNGASE EN CONTACTO</strong>
            </h4>
            <br />
            <p style="color: var(--primary-color); text-align: left;">
              Manténgase actualizado en las redes sociales.
            </p>
            <div class="social">
              <ul>
                <li>
                  <a :href="configData.general.socialNetworks.facebook" target="_blank"
                    ><i class="fa fa-facebook"></i
                  ></a>
                </li>
                <li>
                  <a :href="configData.general.socialNetworks.instagram" target="_blank"
                    ><i class="fa fa-instagram"></i
                  ></a>
                </li>
                <li>
                  <a :href="configData.general.socialNetworks.youtube" target="_blank"
                    ><i class="fa fa-youtube-play"></i
                  ></a>
                </li>
                <li>
                  <a :href="configData.general.socialNetworks.linkedIn" target="_blank"
                    ><i class="fa fa-linkedin"></i
                  ></a>
                </li>
              </ul>
            </div>
            <ul class="accesos">
              <li class="img-libro-reclamaciones">
                <router-link :to="'/reclamo'" class="acceso link-libro-reclamaciones"></router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row sinmargen fondo-gris">
      <div class="container copydev">
        <div class="copyright">
          Copyright © {{ getActualYear() + ' by ' + configData.general.brandShortName }}.
          {{ configData.general.brandShortName }} es una marca registrada. Todos los derechos
          reservados. RUC 20108022702 ARMAQ S.A.. R.G.03448-2023-SUCAMEC/GAMAC
        </div>
        <div class="developed">
          Desarrollado por:
          <a :href="'http://' + configData.general.developerCorporateWebPage"
            ><img src="@/assets/analysofti-logo.png" :alt="configData.general.developerName"
          /></a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'RedesignFooter',
  props: ['section_list', 'configData'],
  methods: {
    getActualYear() {
      var today = new Date();
      var year = today.getFullYear();
      return year;
    },
  },
};
</script>
